import { Injectable, inject } from '@angular/core';
import { SwPush } from '@angular/service-worker';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { firstValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class PushNotificationService {
    private swPush = inject(SwPush);
    private http = inject(HttpClient);

    get isEnabled() {
        return this.swPush.isEnabled;
    }

    get subscription$() {
        return this.swPush.subscription;
    }

    async requestSubscription() {
        if (!this.isEnabled) {
            console.warn('Service worker push notifications are not enabled.');
            return;
        }

        try {
            const sub = await this.swPush.requestSubscription({
                serverPublicKey: environment.vapidPublicKey
            });

            await this.sendSubscriptionToBackend(sub);
            console.log('Successfully subscribed to push notifications');
        } catch (err) {
            console.error('Could not subscribe to push notifications', err);
        }
    }

    private async sendSubscriptionToBackend(sub: PushSubscription) {
        const subObj = sub.toJSON();
        const payload = {
            endpoint: subObj.endpoint,
            p256dh: subObj.keys?.['p256dh'],
            auth: subObj.keys?.['auth']
        };

        return firstValueFrom(this.http.post(`${environment.apiUrl}/api/PushNotification/subscribe`, payload));
    }
}
